<template>
  <load
    v-if="loading"
    class="my-3 py-3"
    mode="table"
    :message="`Buscando por <span class='highlightText'>${search}</span>`"
  />
  <div v-else>
    <form @submit.prevent="submitSearch" ref="search">
      <b-input-group class="mt-3">
        <b-input-group-prepend>
          <b-input-group-text>
            <b-icon icon="search"></b-icon>
          </b-input-group-text>
        </b-input-group-prepend>
        <b-form-input
          :disabled="showResultSearch"
          v-model="search"
          placeholder="Digite um Nome de Usuário, Responsável Familiar, Filiação 1 ou CPF e tecle enter"
          @keyup.enter="findFamilyMember"
        ></b-form-input>
        <b-input-group-append v-if="showResultSearch">
          <b-button
            @click="
              showResultSearch = false;
              search = null;
            "
            variant="danger"
            type="submit"
            data-style="zoom-in"
            class="btn-submit"
          >
            Limpar Busca
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </form>
    <div class="col-12 card" v-if="showResultSearch">
      <!-- <loading-animation
                :active.sync="loading"
                :is-full-page="false"
                :opacity="1"
                color="#5895ff"
            /> -->
      <div class="card-body px-3 py-4">
        <b-table
          :fields="[
            {
              key: 'nome_completo',
              label: $t('Nome'),
            },
            {
              key: 'nome_social',
              label: $t('Nome social'),
            },
            {
              key: 'cpf',
              label: $t('CPF'),
            },
            {
              key: 'data_nascimento',
              label: $t('Nascimento'),
            },
            {
              key: 'mae',
              label: $t('Filiação 1'),
            },
            {
              key: 'estado_cadastral',
            },
            {
              key: 'atualizacao_cadunico',
              label: $t('Atualização CADUNICO'),
            },
            {
              key: 'atualizacao',
              label: $t('Ultima atualização'),
            },
            {
              key: 'actions',
              label: '',
              class: 'text-right',
              thStyle: { width: '95px', minWidth: '95px' },
            },
          ]"
          :items="familiasList"
          striped
          hover
          show-empty
          small
          outlined
          stacked="md"
          table-class="mb-3"
        >
          <template v-slot:cell(nome_completo)="data">
            <strong>
              <span
                v-if="!data.item.nome_social"
                v-html="
                  $options.filters.highlight(
                    data.item.nome_completo,
                    search.trim()
                  )
                "
              ></span>
              <span class="text-center" v-else>-</span>
            </strong>
          </template>
          <template v-slot:cell(nome_social)="data">
            <strong v-if="data.item.nome_social">
              <span
                v-html="
                  $options.filters.highlight(
                    data.item.nome_social,
                    search.trim()
                  )
                "
              ></span>
            </strong>
          </template>
          <template v-slot:cell(cpf)="data">
            <strong>
              <span
                v-if="data.item.documento"
                v-html="
                  $options.filters.highlight(
                    data.item.documento.cpf,
                    search.trim()
                  )
                "
              ></span
            ></strong>
          </template>
          <template v-slot:cell(data_nascimento)="data">
            <strong> {{ data.item.data_nascimento }}</strong>
          </template>

          <template v-slot:cell(mae)="data">
            <strong>
              <span
                v-html="
                  $options.filters.highlight(data.item.mae, search.trim())
                "
              ></span
            ></strong>
          </template>
          <template v-slot:cell(estado_cadastral)="data">
            <span class="small" v-html="data.item.estado_cadastral"></span>
          </template>
          <template v-slot:cell(atualizacao_cadunico)="data">
            <strong> {{ data.item.atualizacao_cadunico }}</strong>
          </template>
          <template v-slot:cell(atualizacao)="data">
            <strong> {{ data.item.atualizacao }}</strong>
          </template>
          <template v-slot:cell()="data">
            <b-button
              :title="$t('Editar Família')"
              :to="'/dashboard/familias/edit/' + data.item.familia_id"
              :class="
                data.item.familia.estado_cadastral == 4 &&
                data.item.familia.estado_cadastral == 5
                  ? 'px-2 mb-0'
                  : 'px-2 m-0'
              "
              size="sm"
              type="button"
              v-b-tooltip.hover
              variant="success"
            >
              <i class="fas fa-edit"></i>
            </b-button>
            <b-dropdown
              no-caret
              variant="info"
              size="sm"
              v-b-tooltip.hover
              right
              title="Serviços/Intervenções"
              v-if="
                data.item.familia.estado_cadastral != 4 &&
                data.item.familia.estado_cadastral != 5
              "
            >
              <template #button-content>
                <i class="fas fa-ellipsis-v"></i>
              </template>
              <b-dropdown-group id="dropdown-group-1" header="Intervenções">
                <b-dropdown-item
                  :to="'/dashboard/atendimentos/' + data.item.familia_id"
                >
                  Atendimentos
                </b-dropdown-item>
                <template v-if="$store.state.user.role_details.name != 'Nível Básico'">
                  <b-dropdown-item
                    :to="
                      '/dashboard/encaminhamentos/' +
                      data.item.familia_id +
                      '?familia_id=' +
                      data.item.familia_id
                    "
                  >
                    Encaminhamentos
                  </b-dropdown-item>
                  <b-dropdown-item
                    :to="
                      '/dashboard/referenciamentos/' +
                      data.item.familia_id +
                      '?familia_id=' +
                      data.item.familia_id
                    "
                  >
                    Referência e Contrarreferência
                  </b-dropdown-item>
                  <b-dropdown-item
                    :to="
                      '/dashboard/medidas/' +
                      data.item.familia_id +
                      '?familia_id=' +
                      data.item.familia_id
                    "
                  >
                    Medidas Socioeducativas
                  </b-dropdown-item>
                  <b-dropdown-item
                    :to="
                      '/dashboard/acompanhamentos/' +
                      data.item.familia_id +
                      '?familia_id=' +
                      data.item.familia_id
                    "
                  >
                    Acompanhamentos
                  </b-dropdown-item>
                  <b-dropdown-item
                    :to="
                      '/dashboard/violacaodedireitos/' +
                      data.item.familia_id +
                      '?familia_id=' +
                      data.item.familia_id
                    "
                  >
                    Violação de Direitos
                  </b-dropdown-item>
                  <b-dropdown-item
                    :to="
                      '/dashboard/acolhimentos/' +
                      data.item.familia_id +
                      '?familia_id=' +
                      data.item.familia_id
                    "
                  >
                    Histórico de Acolhimentos
                  </b-dropdown-item>
                </template>
              </b-dropdown-group>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-group id="dropdown-group-2" header="Serviços" v-if="$store.state.user.role_details.name != 'Nível Básico'">
                <b-dropdown-item
                  :to="
                    '/dashboard/familia/beneficios/' +
                    data.item.familia_id +
                    '?familia_id=' +
                    data.item.familia_id
                  "
                >
                  Benefícios
                </b-dropdown-item>
                <b-dropdown-item
                  :to="
                    '/dashboard/programassociais/beneficiarios/' +
                    data.item.familia_id +
                    '?familia_id=' +
                    data.item.familia_id
                  "
                >
                  Programas Sociais
                </b-dropdown-item>
              </b-dropdown-group>
            </b-dropdown>
          </template>
          <template v-slot:empty="scope">
            <div class="text-center my-5">
              <img
                :alt="$t('No results')"
                class="mb-5"
                src="/img/icons/robot.svg"
                style="max-height: 165px"
              />
              <h3 class="bold">{{ $t("No records found") }}</h3>
            </div>
          </template>
        </b-table>

        <div class="row align-items-center">
          <div class="col-lg-6 col-md-12">
            <div class="form-group d-inline-flex mb-0">
              <select
                class="form-control"
                style="width: 70px"
                v-model="perPage"
                v-on:change="getFamilias(page, perPage)"
              >
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
              </select>
            </div>
            <div class="d-inline-flex ml-2">
              <b-pagination
                :per-page="perPage"
                :total-rows="pagination.total"
                @change="changePage"
                v-model="page"
              />
            </div>
          </div>
          <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
            <div class="float-lg-right">
              {{ $t("Showing page") }}
              {{ pagination.currentPage }}
              de
              {{ pagination.totalPages }}
              {{ $t("pages in") }}
              {{ pagination.total }}
              {{ $t("records") }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    // "search",
    // "familiasList",
    "paginationFamilia",
    "submitsearch",
    // "loading",
    // "filtroFamiliares",
    // "pagination",
  ],
  name: "ResultadoBuscarFamilias",
  data() {
    return {
      page: 1,
      perPage: 4,
      familiasList: {},
      loading: false,
      showResultSearch: false,
      search: "",
      filtroFamiliares: "",
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
    };
  },
  methods: {
    changePage(page) {
      if (
        page > 0 &&
        page <= this.pagination.totalPages &&
        page !== this.page
      ) {
        this.page = page;
        this.getFamilias(this.page, this.perPage);
      }
    },
    findFamilyMember() {
      this.getFamilias();
    },
    getFamilias(page = 1, perPage = 10) {
      this.loading = true;
      axios
        .get("api/dashboard/buscar/usuarios", {
          params: {
            page: page,
            search: this.search,
            perPage: perPage,
            // filtroFamiliares: this.filtroFamiliares
          },
        })
        .then((response) => {
          this.showResultSearch = true;
          this.familiasList = response.data.data;
          this.pagination = response.data.pagination;
          if (this.pagination.totalPages < this.pagination.currentPage) {
            this.page = this.pagination.totalPages;
            this.getFamilias(page, perPage);
          } else {
            this.loading = false;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style>
.highlightText {
  background: yellow;
}
</style>
